import React, {useState} from 'react';


export const HeaterIcon = ({toggleable = false}) => {
    const [isActive, setIsActive] = useState(false);

    const handleClick = () => {
        if (toggleable) {
            setIsActive(prevIsActive => !prevIsActive);
        }
    };
    const className = `icon toggleable ${toggleable && isActive ? 'active' : ''}`;
    return (
        <svg className={className} width="35" height="35" viewBox="0 0 35 35" fill="none"
             xmlns="http://www.w3.org/2000/svg" onClick={handleClick}>
            <path
                d="M16.0426 4.375C16.0426 4.375 14.3829 10.9375 17.3997 17.5C20.4166 24.0625 19.6874 30.625 19.6874 30.625M27.6081 30.625C27.6081 30.625 28.5844 24.0625 25.5218 18.9583C22.4593 13.8542 23.3343 8.75 23.3343 8.75M11.5643 30.625C11.5643 30.625 12.5406 24.0625 9.47802 18.9583C6.41547 13.8542 7.29052 8.75 7.29052 8.75"
                stroke="#444444" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}

export const SettingIcon = () => {
    return (
        <svg className="icon setting-icon" width="31" height="31" viewBox="0 0 31 31" fill="none"
             xmlns="http://www.w3.org/2000/svg">
            <path
                d="M12.3923 5.08917C12.5085 4.38908 13.1156 3.875 13.826 3.875H17.1753C17.8858 3.875 18.4928 4.38908 18.6091 5.08917L18.8842 6.74379C18.9656 7.22688 19.2885 7.62987 19.7173 7.86754C19.8129 7.91921 19.9072 7.97475 20.0015 8.03158C20.4213 8.28475 20.9315 8.36354 21.39 8.19175L22.962 7.60275C23.2841 7.4816 23.6388 7.47872 23.9629 7.59463C24.2869 7.71053 24.5593 7.9377 24.7316 8.23567L26.4056 11.138C26.5774 11.436 26.638 11.7853 26.5765 12.1238C26.515 12.4623 26.3355 12.7679 26.0698 12.9864L24.7742 14.0546C24.3958 14.3659 24.2085 14.8464 24.2188 15.336C24.2206 15.4457 24.2206 15.5555 24.2188 15.6653C24.2085 16.1536 24.3958 16.6341 24.7742 16.9454L26.071 18.0136C26.6187 18.4657 26.7608 19.2471 26.4069 19.8607L24.7303 22.763C24.5583 23.0609 24.2862 23.2882 23.9624 23.4043C23.6386 23.5204 23.2841 23.5179 22.962 23.3972L21.39 22.8083C20.9315 22.6365 20.4213 22.7152 20.0002 22.9684C19.9066 23.0254 19.8118 23.0805 19.716 23.1337C19.2885 23.3701 18.9656 23.7731 18.8842 24.2562L18.6091 25.9108C18.4928 26.6122 17.8858 27.125 17.1753 27.125H13.8247C13.1143 27.125 12.5085 26.6109 12.391 25.9108L12.1159 24.2562C12.0358 23.7731 11.7129 23.3701 11.284 23.1325C11.1883 23.0796 11.0935 23.0249 10.9999 22.9684C10.5801 22.7152 10.0699 22.6365 9.61004 22.8083L8.03808 23.3972C7.71611 23.5181 7.36172 23.5207 7.03795 23.4049C6.71417 23.289 6.44198 23.062 6.26979 22.7643L4.5945 19.862C4.42263 19.564 4.36206 19.2147 4.42356 18.8762C4.48505 18.5377 4.66463 18.2321 4.93033 18.0136L6.22717 16.9454C6.60433 16.6354 6.79162 16.1536 6.78258 15.6653C6.78056 15.5556 6.78056 15.4457 6.78258 15.336C6.79162 14.8451 6.60433 14.3659 6.22717 14.0546L4.93033 12.9864C4.66495 12.768 4.48558 12.4626 4.42409 12.1244C4.36261 11.7862 4.42299 11.4372 4.5945 11.1393L6.26979 8.23696C6.44182 7.93876 6.71414 7.71132 7.03822 7.59518C7.3623 7.47903 7.71709 7.48171 8.03937 7.60275L9.61004 8.19175C10.0699 8.36354 10.5801 8.28475 10.9999 8.03158C11.0929 7.97475 11.1885 7.9205 11.284 7.86625C11.7129 7.62988 12.0358 7.22688 12.1159 6.74379L12.3923 5.08917Z"
                stroke="#444444" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path
                d="M19.375 15.5C19.375 16.5277 18.9667 17.5133 18.24 18.24C17.5133 18.9667 16.5277 19.375 15.5 19.375C14.4723 19.375 13.4867 18.9667 12.76 18.24C12.0333 17.5133 11.625 16.5277 11.625 15.5C11.625 14.4723 12.0333 13.4867 12.76 12.76C13.4867 12.0333 14.4723 11.625 15.5 11.625C16.5277 11.625 17.5133 12.0333 18.24 12.76C18.9667 13.4867 19.375 14.4723 19.375 15.5Z"
                stroke="#444444" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}

export const ShoppingBagIcon = () => {
    return (

        <svg className="icon shopping-bag-icon" width="31" height="31" viewBox="0 0 31 31" fill="none"
             xmlns="http://www.w3.org/2000/svg">
            <path
                d="M19.5142 13.8846V9.03846C19.5142 7.9674 19.0913 6.9402 18.3386 6.18284C17.5859 5.42548 16.565 5 15.5005 5C14.436 5 13.4151 5.42548 12.6623 6.18284C11.9096 6.9402 11.4867 7.9674 11.4867 9.03846V13.8846M23.6414 11.7383L24.9932 24.6614C25.0682 25.3775 24.5116 26 23.7955 26H7.20541C7.03652 26.0002 6.86948 25.9646 6.71515 25.8956C6.56081 25.8266 6.42262 25.7257 6.30957 25.5995C6.19652 25.4732 6.11112 25.3245 6.05893 25.1628C6.00674 25.0012 5.98893 24.8304 6.00664 24.6614L7.35954 11.7383C7.39075 11.4406 7.53039 11.1651 7.75155 10.9648C7.97271 10.7646 8.25972 10.6538 8.55724 10.6538H22.4437C23.0602 10.6538 23.5772 11.1223 23.6414 11.7383ZM11.8881 13.8846C11.8881 13.9917 11.8458 14.0944 11.7705 14.1702C11.6953 14.2459 11.5932 14.2885 11.4867 14.2885C11.3803 14.2885 11.2782 14.2459 11.2029 14.1702C11.1276 14.0944 11.0854 13.9917 11.0854 13.8846C11.0854 13.7775 11.1276 13.6748 11.2029 13.5991C11.2782 13.5233 11.3803 13.4808 11.4867 13.4808C11.5932 13.4808 11.6953 13.5233 11.7705 13.5991C11.8458 13.6748 11.8881 13.7775 11.8881 13.8846ZM19.9156 13.8846C19.9156 13.9917 19.8733 14.0944 19.798 14.1702C19.7228 14.2459 19.6207 14.2885 19.5142 14.2885C19.4078 14.2885 19.3057 14.2459 19.2304 14.1702C19.1551 14.0944 19.1128 13.9917 19.1128 13.8846C19.1128 13.7775 19.1551 13.6748 19.2304 13.5991C19.3057 13.5233 19.4078 13.4808 19.5142 13.4808C19.6207 13.4808 19.7228 13.5233 19.798 13.5991C19.8733 13.6748 19.9156 13.7775 19.9156 13.8846Z"
                stroke="#444444" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>

    )
}

export const ShoppingIcon = () => {
    return (
        <svg className="icon  shopping-icon" width="27" height="27" viewBox="0 0 24 24" fill="none"
             xmlns="http://www.w3.org/2000/svg">
            <path
                d="M2.25 3H3.636C4.146 3 4.591 3.343 4.723 3.835L5.106 5.272M5.106 5.272C10.6766 5.11589 16.2419 5.73515 21.642 7.112C20.818 9.566 19.839 11.95 18.718 14.25H7.5M5.106 5.272L7.5 14.25M7.5 14.25C6.70435 14.25 5.94129 14.5661 5.37868 15.1287C4.81607 15.6913 4.5 16.4544 4.5 17.25H20.25M6 20.25C6 20.4489 5.92098 20.6397 5.78033 20.7803C5.63968 20.921 5.44891 21 5.25 21C5.05109 21 4.86032 20.921 4.71967 20.7803C4.57902 20.6397 4.5 20.4489 4.5 20.25C4.5 20.0511 4.57902 19.8603 4.71967 19.7197C4.86032 19.579 5.05109 19.5 5.25 19.5C5.44891 19.5 5.63968 19.579 5.78033 19.7197C5.92098 19.8603 6 20.0511 6 20.25ZM18.75 20.25C18.75 20.4489 18.671 20.6397 18.5303 20.7803C18.3897 20.921 18.1989 21 18 21C17.8011 21 17.6103 20.921 17.4697 20.7803C17.329 20.6397 17.25 20.4489 17.25 20.25C17.25 20.0511 17.329 19.8603 17.4697 19.7197C17.6103 19.579 17.8011 19.5 18 19.5C18.1989 19.5 18.3897 19.579 18.5303 19.7197C18.671 19.8603 18.75 20.0511 18.75 20.25Z"
                stroke="#444444" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}

export const MenuOpenIcon = () => {
    return (
        <svg className="icon  menu-open-icon" width="18" height="18" viewBox="0 0 18 18" fill="none"
             xmlns="http://www.w3.org/2000/svg">
            <path d="M6.1875 3.375L11.8125 9L6.1875 14.625" stroke="#231F20" strokeWidth="1.5" strokeLinecap="round"
                  strokeLinejoin="round"/>
        </svg>
    )

}


export const TroubleShootIcon = () => {
    return (
        <svg className="icon Trouble-Shoot-icon" width="30" height="30" viewBox="0 0 30 30" fill="none"
             xmlns="http://www.w3.org/2000/svg">
            <path
                d="M27.1875 8.43749C27.1876 9.21668 27.0258 9.98739 26.7123 10.7008C26.3989 11.4141 25.9407 12.0546 25.3667 12.5815C24.7927 13.1085 24.1155 13.5105 23.3781 13.762C22.6406 14.0135 21.8589 14.109 21.0825 14.0425C19.7375 13.9287 18.2525 14.1312 17.395 15.1725L8.45503 26.0275C8.17301 26.3713 7.82215 26.6522 7.42502 26.8521C7.02789 27.0521 6.59329 27.1667 6.14919 27.1885C5.70509 27.2104 5.26134 27.139 4.84649 26.979C4.43164 26.819 4.05489 26.5739 3.74048 26.2595C3.42608 25.9451 3.18099 25.5684 3.02098 25.1535C2.86098 24.7387 2.78961 24.2949 2.81147 23.8508C2.83333 23.4067 2.94793 22.9721 3.14789 22.575C3.34786 22.1779 3.62877 21.827 3.97253 21.545L14.8275 12.605C15.8688 11.7475 16.0713 10.2625 15.9575 8.91749C15.8736 7.94021 16.0467 6.95797 16.4596 6.06824C16.8726 5.17851 17.511 4.41223 18.3115 3.84543C19.1121 3.27863 20.0469 2.93102 21.0233 2.8371C21.9997 2.74317 22.9836 2.9062 23.8775 3.30999L19.7825 7.40499C19.9409 8.09011 20.2886 8.71698 20.7858 9.21421C21.283 9.71145 21.9099 10.0591 22.595 10.2175L26.69 6.12249C27.01 6.82874 27.1875 7.61249 27.1875 8.43749Z"
                stroke="#444444" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M6.08374 23.9062H6.09374V23.9162H6.08374V23.9062Z" stroke="#444444" strokeWidth="1.5"
                  strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )

}


export const WarrantyIcon = () => {
    return (
        <svg className="icon warranty-icon" width="30" height="30" viewBox="0 0 30 30" fill="none"
             xmlns="http://www.w3.org/2000/svg">
            <path
                d="M12.5529 2.40878C13.5127 1.24696 15.2934 1.24696 16.2533 2.40878L17.6933 4.15175C18.2011 4.7664 18.981 5.08873 19.7746 5.01197L22.0284 4.79394C23.5321 4.64846 24.7948 5.91199 24.6481 7.41569L24.4315 9.63755C24.3538 10.435 24.6791 11.2186 25.2987 11.7265L27.0277 13.144C28.1991 14.1041 28.1991 15.8959 27.0277 16.856L25.2987 18.2735C24.6791 18.7814 24.3538 19.565 24.4315 20.3624L24.6481 22.5844C24.7948 24.088 23.5321 25.3516 22.0284 25.206L19.7746 24.9881C18.981 24.9113 18.2011 25.2336 17.6933 25.8482L16.2533 27.5912C15.2934 28.7531 13.5127 28.7531 12.5529 27.5912L11.1129 25.8482C10.605 25.2336 9.82514 24.9113 9.03155 24.9881L6.7778 25.206C5.27399 25.3516 4.01142 24.088 4.15803 22.5844L4.37465 20.3624C4.4524 19.565 4.1271 18.7814 3.50748 18.2735L1.7784 16.856C0.607069 15.8959 0.607069 14.1041 1.7784 13.144L3.50748 11.7265C4.1271 11.2186 4.4524 10.435 4.37465 9.63755L4.15803 7.41569C4.01142 5.91199 5.27399 4.64846 6.7778 4.79394L9.03155 5.01197C9.82514 5.08873 10.605 4.7664 11.1129 4.15175L12.5529 2.40878Z"
                stroke="#231F20" strokeWidth="1.5"/>
            <path d="M9.75049 15.927L12.4962 18.6619C13.0123 19.176 13.8636 19.1155 14.3017 18.5335L19.056 12.2193"
                  stroke="#231F20" strokeWidth="1.5" strokeLinecap="round"/>
        </svg>
    )
}

export const ManualIcon = () => {
    return (
        <svg className="icon manual-icon" width="30" height="30" viewBox="0 0 30 30" fill="none"
             xmlns="http://www.w3.org/2000/svg">
            <path
                d="M15 7.5525C12.9395 5.70419 10.268 4.68367 7.5 4.6875C6.185 4.6875 4.9225 4.9125 3.75 5.3275V23.14C4.95453 22.715 6.22271 22.4986 7.5 22.5C10.3813 22.5 13.01 23.5837 15 25.365M15 7.5525C17.0604 5.70409 19.732 4.68356 22.5 4.6875C23.815 4.6875 25.0775 4.9125 26.25 5.3275V23.14C25.0455 22.715 23.7773 22.4986 22.5 22.5C19.732 22.4962 17.0605 23.5167 15 25.365M15 7.5525V25.365"
                stroke="#231F20" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}


export const ScheduleIcon = () => {
    return (
        <svg className="icon schedule-icon" width="26" height="26" viewBox="0 0 26 26" fill="none"
             xmlns="http://www.w3.org/2000/svg">
            <path
                d="M7.3125 3.25V5.6875M18.6875 3.25V5.6875M3.25 20.3125V8.125C3.25 7.47853 3.50681 6.85855 3.96393 6.40143C4.42105 5.94431 5.04103 5.6875 5.6875 5.6875H20.3125C20.959 5.6875 21.579 5.94431 22.0361 6.40143C22.4932 6.85855 22.75 7.47853 22.75 8.125V20.3125M3.25 20.3125C3.25 20.959 3.50681 21.579 3.96393 22.0361C4.42105 22.4932 5.04103 22.75 5.6875 22.75H20.3125C20.959 22.75 21.579 22.4932 22.0361 22.0361C22.4932 21.579 22.75 20.959 22.75 20.3125M3.25 20.3125V12.1875C3.25 11.541 3.50681 10.921 3.96393 10.4639C4.42105 10.0068 5.04103 9.75 5.6875 9.75H20.3125C20.959 9.75 21.579 10.0068 22.0361 10.4639C22.4932 10.921 22.75 11.541 22.75 12.1875V20.3125"
                stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}


export const ContactUsIcon = () => {
    return (
        <svg className="icon contact-us-icon" width="30" height="30" viewBox="0 0 30 30" fill="none"
             xmlns="http://www.w3.org/2000/svg">
            <path
                d="M2.8125 8.4375C2.8125 18.7925 11.2075 27.1875 21.5625 27.1875H24.375C25.1209 27.1875 25.8363 26.8912 26.3637 26.3637C26.8912 25.8363 27.1875 25.1209 27.1875 24.375V22.66C27.1875 22.015 26.7488 21.4525 26.1225 21.2963L20.5938 19.9137C20.0438 19.7762 19.4663 19.9825 19.1275 20.435L17.915 22.0513C17.5625 22.5213 16.9537 22.7287 16.4025 22.5262C14.3561 21.7739 12.4977 20.5857 10.956 19.044C9.41426 17.5023 8.22609 15.6439 7.47375 13.5975C7.27125 13.0463 7.47875 12.4375 7.94875 12.085L9.565 10.8725C10.0187 10.5337 10.2238 9.955 10.0863 9.40625L8.70375 3.8775C8.62767 3.57337 8.45215 3.30338 8.20507 3.11042C7.95798 2.91746 7.6535 2.8126 7.34 2.8125H5.625C4.87908 2.8125 4.16371 3.10882 3.63626 3.63626C3.10882 4.16371 2.8125 4.87908 2.8125 5.625V8.4375Z"
                stroke="#231F20" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )

}

export const FiltrationIcon = () => {
    return (
        <svg className="icon filteration-icon" width="31" height="31" viewBox="0 0 31 26" fill="none"
             xmlns="http://www.w3.org/2000/svg">
            <path
                d="M24.4048 20V25H7.5V8M12 8C17 7 16 5.5 20 5.5C22.8378 5.5 22.904 6.48211 24.4048 7.21521M29.5 8C26.7008 8 25.2984 7.65175 24.4048 7.21521M7.5 8V1.5H24.4048V7.21521M7.5 8C3.9 7.6 2 7.16667 1.5 7M7.5 13.5C3.9 13.1 2 12.6667 1.5 12.5M7.5 18.5C3.9 18.1 2 17.6667 1.5 17.5M12 13.5C17 12.5 16 11 20 11C24.5277 11 22 13.5 29.5 13.5M12 18.5C17 17.5 16 16 20 16C24.5277 16 22 18.5 29.5 18.5"
                stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}

export const EcoModeIcon = () => {
    return (
        <svg className="icon filteration-icon" width="31" height="31" viewBox="0 0 31 26" fill="none"
             xmlns="http://www.w3.org/2000/svg">
            <path
                d="M11.983 1.907a.75.75 0 0 0-1.292-.657l-8.5 9.5A.75.75 0 0 0 2.75 12h6.572l-1.305 6.093a.75.75 0 0 0 1.292.657l8.5-9.5A.75.75 0 0 0 17.25 8h-6.572l1.305-6.093Z"
                stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>

        </svg>
    )
}


export const TubIcon = () => {
    return (
        <svg className="icon Tub-icon" width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M2.8125 16.875H22.3638H27.1875M2.8125 17.2975V22.5C2.8125 23.2459 3.10882 23.9613 3.63626 24.4887C4.16371 25.0162 4.87908 25.3125 5.625 25.3125H24.375C25.1209 25.3125 25.8363 25.0162 26.3637 24.4887C26.8912 23.9613 27.1875 23.2459 27.1875 22.5V17.2975C27.1875 17.0175 27.145 16.7388 27.0625 16.4713L24.05 6.6725C23.8731 6.0978 23.5166 5.59494 23.0329 5.23769C22.5493 4.88044 21.9638 4.68761 21.3625 4.6875H8.63875C8.03744 4.68761 7.45199 4.88044 6.96831 5.23769C6.48462 5.59494 6.12817 6.0978 5.95125 6.6725L2.9375 16.4713C2.85492 16.7389 2.81279 17.0174 2.8125 17.2975ZM8.63875 7.5L6.96831 14H23.0329L21.3625 7.32832L8.63875 7.5Z"
                stroke="#231F20" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )

}


export const BackChevronIcon = () => {
    return (
        <svg className="icon back-chevron-icon" width="24" height="30" viewBox="0 0 24 30" fill="none"
             xmlns="http://www.w3.org/2000/svg">
            <path d="M15.75 24.375L8.25 15L15.75 5.625" stroke="#231F20" strokeWidth="1.5" strokeLinecap="round"
                  strokeLinejoin="round"/>
        </svg>


    )

}

export const DownChevronIcon = () => {
    return (
        <svg className="icon down-chevron-icon" width="24" height="30" xmlns="http://www.w3.org/2000/svg" fill="none"
             viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5"/>
        </svg>
    )

}

export const DownloadIcon = () => {
    return (
        <svg viewBox="0 0 24 24" width="28" height="28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
            <g id="SVGRepo_iconCarrier">
                <path
                    d="M5.25589 16C3.8899 15.0291 3 13.4422 3 11.6493C3 9.20008 4.8 6.9375 7.5 6.5C8.34694 4.48637 10.3514 3 12.6893 3C15.684 3 18.1317 5.32251 18.3 8.25C19.8893 8.94488 21 10.6503 21 12.4969C21 14.0582 20.206 15.4339 19 16.2417M12 21V11M12 21L9 18M12 21L15 18"
                    stroke="var(--font-black)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
            </g>
        </svg>
    )
}

export const LeftOnFilterIcon = () => {
    return (
        <svg className="icon right-filter-icon" width="22" height="37" viewBox="0 0 22 37" fill="none"
             style={{transform: 'scaleX(-1)'}}
             xmlns="http://www.w3.org/2000/svg">
            <path
                d="M11.2 31.0828C17.6 30.825 19 26.3473 19 26.3473L21 4.04168C21 4.04168 18.24 1.1424 11.2 1.01348C4.16 0.884567 1.46667 1.71178 1 2.14151V30.1159C1.39692 30.3485 2.4774 30.6881 4.4 30.9098M11.2 31.0828C8.26402 31.2011 6.02953 31.0978 4.4 30.9098M11.2 31.0828V35.3347C10.6667 35.6033 9.12 36.1082 7.2 35.9793C5.28 35.8504 4.53333 35.4959 4.4 35.3347V30.9098"
                stroke="black" strokeWidth="1.5" strokeLinejoin="round"/>
        </svg>
    )

}

export const RightOnFilterIcon = () => {
    return (
        <svg className="icon right-filter-icon" width="22" height="37" viewBox="0 0 22 37" fill="none"
             xmlns="http://www.w3.org/2000/svg">
            <path
                d="M11.2 31.0828C17.6 30.825 19 26.3473 19 26.3473L21 4.04168C21 4.04168 18.24 1.1424 11.2 1.01348C4.16 0.884567 1.46667 1.71178 1 2.14151V30.1159C1.39692 30.3485 2.4774 30.6881 4.4 30.9098M11.2 31.0828C8.26402 31.2011 6.02953 31.0978 4.4 30.9098M11.2 31.0828V35.3347C10.6667 35.6033 9.12 36.1082 7.2 35.9793C5.28 35.8504 4.53333 35.4959 4.4 35.3347V30.9098"
                stroke="black" strokeWidth="1.5" strokeLinejoin="round"/>
        </svg>
    )

}


export const LeftOffFilterIcon = () => {
    return (
        <svg className="icon left-filter-icon" width="22" height="37" viewBox="0 0 22 37" fill="none"
             xmlns="http://www.w3.org/2000/svg">
            <path
                d="M10.8 31.0828C4.4 30.825 3 26.3473 3 26.3473L1 4.04168C1 4.04168 3.76 1.1424 10.8 1.01348C17.84 0.884567 20.5333 1.71178 21 2.14151V30.1159C20.6031 30.3485 19.5226 30.6881 17.6 30.9098M10.8 31.0828C13.736 31.2011 15.9705 31.0978 17.6 30.9098M10.8 31.0828V35.3347C11.3333 35.6033 12.88 36.1082 14.8 35.9793C16.72 35.8504 17.4667 35.4959 17.6 35.3347V30.9098"
                stroke="#797D82" strokeOpacity="0.31" strokeWidth="1.5" strokeLinejoin="round" strokeDasharray="3 1"/>
        </svg>
    )
}

export const RightOffFilterIcon = () => {
    return (
        <svg className="icon left-filter-icon" width="22" height="37" viewBox="0 0 22 37" fill="none" style={{ transform: 'scaleX(-1)'}}
             xmlns="http://www.w3.org/2000/svg">
            <path
                d="M10.8 31.0828C4.4 30.825 3 26.3473 3 26.3473L1 4.04168C1 4.04168 3.76 1.1424 10.8 1.01348C17.84 0.884567 20.5333 1.71178 21 2.14151V30.1159C20.6031 30.3485 19.5226 30.6881 17.6 30.9098M10.8 31.0828C13.736 31.2011 15.9705 31.0978 17.6 30.9098M10.8 31.0828V35.3347C11.3333 35.6033 12.88 36.1082 14.8 35.9793C16.72 35.8504 17.4667 35.4959 17.6 35.3347V30.9098"
                stroke="#797D82" strokeOpacity="0.31" strokeWidth="1.5" strokeLinejoin="round" strokeDasharray="3 1"/>
        </svg>
    )
}


export const WarningNotificationIcon = () => {
    return (
        <svg className="icon warning-notification-icon" width="14" height="14" viewBox="0 0 14 14" fill="none"
             xmlns="http://www.w3.org/2000/svg">
            <circle cx="7" cy="7" r="6" fill="var(--color-danger)" stroke="white" strokeWidth="1.5"/>
            <text x="5" y="7" fontSize="10" fill="white" transform="translate(0.45 3)" fontWeight="bold">!</text>
            {/* <path d="M7 4.33333V7.66667M7 9.66667H7.00667" stroke="white" stroke-linecap="round"/> */}
        </svg>
    )

}

export const ElectrodeIcon = () => {
    return (
<svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M20 16.6742C12.7123 19.5903 9.43262 19.9548 1.05163 16.6742C1.05163 13.0569 0.508747 7.50074 2.94368 4.58288C3.41358 5.77717 5.06007 9.06148 5.06007 12.6444C5.06007 14.1226 6.95491 15.5968 7.24642 12.6645C7.53794 9.73226 5.31772 5.09858 4.35337 3.15836C5.46369 2.22227 5.42431 2.05787 6.88188 1.72903C8.48299 5.89323 11.0413 10.2558 11.2547 12.6444C11.452 14.8516 13.4411 14.8516 13.4411 12.3C13.4411 9.74839 9.43262 1 9.43262 1C10.3643 1 11.549 1.10532 12.3478 1.36452C12.3478 1.36452 15.6274 9.01936 15.9918 11.9355C16.3562 14.8516 18.178 13.3936 18.178 11.9355C18.178 10.4774 16.6323 5.05725 15.9918 3.55161C18.9068 3.55161 20 7.56129 20 16.6742Z" stroke="#797D82" strokeLinecap="round" strokeLinejoin="round"/>
</svg>
    )

}

export const ElectrodeBoostIcon = ({toggleable = false}) => {
    const [isActive, setIsActive] = useState(false);

    const handleClick = () => {
        if (toggleable) {
            setIsActive(prevIsActive => !prevIsActive);
        }
    };
    const className = `icon toggleable ${toggleable && isActive ? 'active' : ''}`;
    return (
        <svg className={className} width="39" height="39" viewBox="0 0 39 39" fill="none"
             xmlns="http://www.w3.org/2000/svg" onClick={handleClick}>
            <path
                d="M17.723 28.8571C12.9551 29.4126 8.30226 28.3678 1.07609 25.3821C1.07609 19.7552 0.276048 11.1123 3.86437 6.57337C4.55685 8.43116 6.98326 13.5401 6.98326 19.1134C6.98326 21.4129 9.77566 23.7061 10.2053 19.1448C10.6349 14.5835 7.36296 7.37557 5.94181 4.35744C7.57806 2.90131 7.52003 2.64558 9.66803 2.13405C12.0276 8.6117 15.7976 15.3979 16.1122 19.1134C16.403 22.547 19.3342 22.547 19.3342 18.5778C19.3342 14.6086 13.427 1 13.427 1C14.8 1 16.5459 1.16383 17.723 1.56703C17.723 1.56703 22.5562 13.4746 23.0932 18.0108C23.6302 22.547 26.315 20.2789 26.315 18.0108C26.315 15.7427 24.0371 7.31128 23.0932 4.96918C26.4225 4.96918 28.3961 7.71552 29 16M21.75 27.5L34 13.5L30 24.5H38.25L27 38L30 27.5H21.75Z"
                stroke="#444444" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )

}

export const LogoutIcon = ({flipped = false}) => {
    return (
        <svg style={ flipped ? { transform: "scaleX(-1)"} : {}} width="20" height="20" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384.971 384.971">
            <g id="Sign_Out">
                <path d="M180.455,360.91H24.061V24.061h156.394c6.641,0,12.03-5.39,12.03-12.03s-5.39-12.03-12.03-12.03H12.03
                    C5.39,0.001,0,5.39,0,12.031V372.94c0,6.641,5.39,12.03,12.03,12.03h168.424c6.641,0,12.03-5.39,12.03-12.03
                    C192.485,366.299,187.095,360.91,180.455,360.91z"/>
                <path d="M381.481,184.088l-83.009-84.2c-4.704-4.752-12.319-4.74-17.011,0c-4.704,4.74-4.704,12.439,0,17.179l62.558,63.46H96.279
                    c-6.641,0-12.03,5.438-12.03,12.151c0,6.713,5.39,12.151,12.03,12.151h247.74l-62.558,63.46c-4.704,4.752-4.704,12.439,0,17.179
                    c4.704,4.752,12.319,4.752,17.011,0l82.997-84.2C386.113,196.588,386.161,188.756,381.481,184.088z"/>
            </g>
        </svg>
    );
}

export const ElectrodeIconWithIndicator = () => {
    return (
        <svg width="38" height="35" viewBox="0 0 38 35" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M36.9614 29.5342C23.1638 34.9137 16.9542 35.4463 1.08666 29.3944C1.08666 27.768 1.02561 25.9291 1 24C1 24 5.83161 26.7671 9.98225 27.4589C14.1329 28.1506 15.5167 28.2905 18.9756 28.2905C22.4345 28.2905 26.5848 27.4589 31.4272 26.7671C36.2697 26.0753 36.9614 24.6918 36.9614 24.6918C37.0234 26.4412 36.9614 27.5172 36.9614 29.5342Z"
                fill="#EC0000" fillOpacity="0.54"/>
            <path
                d="M36.9722 29.9147C23.1746 35.2942 16.9653 35.9666 1.09776 29.9147C1.09776 23.2418 0.0699227 12.9921 4.67993 7.60945C5.56957 9.8126 8.68683 15.8713 8.68683 22.4807C8.68683 25.2076 12.2743 27.9271 12.8262 22.5179C13.3781 17.1087 9.17464 8.56078 7.34885 4.98159C9.45099 3.25476 9.37643 2.95149 12.136 2.34487C15.1674 10.0267 20.0109 18.0744 20.4151 22.4807C20.7886 26.5525 24.5544 26.5525 24.5544 21.8455C24.5544 17.1384 16.9653 1 16.9653 1C18.7292 1 20.9722 1.19428 22.4844 1.67243C22.4844 1.67243 28.6938 15.7936 29.3837 21.173C30.0736 26.5525 33.5228 23.8628 33.5228 21.173C33.5228 18.4833 30.5962 8.48453 29.3837 5.70704C34.9026 5.70704 36.9722 13.1038 36.9722 29.9147Z"
                stroke="#444444" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
}

export const PersonIcon = () => {
    return (
        <svg 
        className="icon person-icon" 
        
        width="12" height="29" viewBox="0 0 12 29" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2.34016 27C2.34016 27 0.186163 16.0977 1.33976 13.5C2.49336 10.9023 4.22149 11 5.83976 11C7.45804 11 9.18616 10.9023 10.3398 13.5C11.4934 16.0977 9.34017 27 9.34017 27C9.34017 27 7.96808 27.5066 5.83976 27.5C3.6392 27.5 2.34016 27 2.34016 27Z" stroke="#797D82" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M8.31472 6.97487C8.97109 6.3185 9.33984 5.42826 9.33984 4.5C9.33984 3.57174 8.97109 2.6815 8.31472 2.02513C7.65834 1.36875 6.7681 1 5.83984 1C4.91159 1 4.02135 1.36875 3.36497 2.02513C2.70859 2.6815 2.33984 3.57174 2.33984 4.5C2.33984 5.42826 2.70859 6.3185 3.36497 6.97487C4.02135 7.63125 4.91159 8 5.83984 8C6.7681 8 7.65834 7.63125 8.31472 6.97487Z" stroke="#797D82" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
}
export const AccountIcon = () => {
    return (
        <svg className="icon account-icon" width="30" height="30" viewBox="0 0 24 24" fill="none">
        <path 
            d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z"
            stroke="#231F20" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )

}

export const UsersIcon = () => {
    return (
        <svg className="icon users-icon" width="30" height="30" viewBox="0 0 24 24" fill="none">
        <path 
            d="M15 19.128a9.38 9.38 0 0 0 2.625.372 9.337 9.337 0 0 0 4.121-.952 4.125 4.125 0 0 0-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 0 1 8.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0 1 11.964-3.07M12 6.375a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0Zm8.25 2.25a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z"
            stroke="#231F20" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}

export const DealershipIcon = () => {
    return (
        <svg className="icon users-icon" width="30" height="30" viewBox="0 0 24 24" fill="none">
        <path 
            d="M13.5 21v-7.5a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 .75.75V21m-4.5 0H2.36m11.14 0H18m0 0h3.64m-1.39 0V9.349M3.75 21V9.349m0 0a3.001 3.001 0 0 0 3.75-.615A2.993 2.993 0 0 0 9.75 9.75c.896 0 1.7-.393 2.25-1.016a2.993 2.993 0 0 0 2.25 1.016c.896 0 1.7-.393 2.25-1.015a3.001 3.001 0 0 0 3.75.614m-16.5 0a3.004 3.004 0 0 1-.621-4.72l1.189-1.19A1.5 1.5 0 0 1 5.378 3h13.243a1.5 1.5 0 0 1 1.06.44l1.19 1.189a3 3 0 0 1-.621 4.72M6.75 18h3.75a.75.75 0 0 0 .75-.75V13.5a.75.75 0 0 0-.75-.75H6.75a.75.75 0 0 0-.75.75v3.75c0 .414.336.75.75.75Z"
            stroke="#231F20" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}

export const CommentsIcon = () => {
    return (
        <svg className="icon users-icon" width="30" height="30" viewBox="0 0 24 24" fill="none">
        <path 
            d="M7.5 8.25h9m-9 3H12m-9.75 1.51c0 1.6 1.123 2.994 2.707 3.227 1.129.166 2.27.293 3.423.379.35.026.67.21.865.501L12 21l2.755-4.133a1.14 1.14 0 0 1 .865-.501 48.172 48.172 0 0 0 3.423-.379c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z"
            stroke="#231F20" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}

export const FirmwareIcon = () => {
    return (
        <svg className="icon users-icon" width="30" height="30" viewBox="0 0 24 24" fill="none">
        <path 
           d="M11.42 15.17 17.25 21A2.652 2.652 0 0 0 21 17.25l-5.877-5.877M11.42 15.17l2.496-3.03c.317-.384.74-.626 1.208-.766M11.42 15.17l-4.655 5.653a2.548 2.548 0 1 1-3.586-3.586l6.837-5.63m5.108-.233c.55-.164 1.163-.188 1.743-.14a4.5 4.5 0 0 0 4.486-6.336l-3.276 3.277a3.004 3.004 0 0 1-2.25-2.25l3.276-3.276a4.5 4.5 0 0 0-6.336 4.486c.091 1.076-.071 2.264-.904 2.95l-.102.085m-1.745 1.437L5.909 7.5H4.5L2.25 3.75l1.5-1.5L7.5 4.5v1.409l4.26 4.26m-1.745 1.437 1.745-1.437m6.615 8.206L15.75 15.75M4.867 19.125h.008v.008h-.008v-.008Z"
            stroke="#231F20" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}

export const LogsIcon = () => {
    return (
        <svg className="icon users-icon" width="30" height="30" viewBox="0 0 24 24" fill="none">
        <path 
           d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
            stroke="#231F20" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}

export const FirmwareManagement = () => {
    return (
        <svg className="icon users-icon" width="30" height="30" viewBox="0 0 24 24" fill="none">
            <path strokeLinecap="round" strokeLinejoin="round" 
            d="M8.25 3v1.5M4.5 8.25H3m18 0h-1.5M4.5 12H3m18 0h-1.5m-15 3.75H3m18 0h-1.5M8.25 19.5V21M12 3v1.5m0 15V21m3.75-18v1.5m0 15V21m-9-1.5h10.5a2.25 2.25 0 0 0 2.25-2.25V6.75a2.25 2.25 0 0 0-2.25-2.25H6.75A2.25 2.25 0 0 0 4.5 6.75v10.5a2.25 2.25 0 0 0 2.25 2.25Zm.75-12h9v9h-9v-9Z" />
        </svg>
    )
}

export const ControlIcon = () => {
    return (
        <svg className="icon table-icon" width="30" height="30" viewBox="0 0 24 24" fill="none">
        <path 
            d="M10.5 6h9.75M10.5 6a1.5 1.5 0 1 1-3 0m3 0a1.5 1.5 0 1 0-3 0M3.75 6H7.5m3 12h9.75m-9.75 0a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m-3.75 0H7.5m9-6h3.75m-3.75 0a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m-9.75 0h9.75"
            stroke="#231F20" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}

export const HistoryIcon = () => {
    return (
        <svg className="icon users-icon" width="30" height="30" viewBox="0 0 24 24" fill="none">
        <path 
            d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
            strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" stroke="#231F20"/>
        </svg>
    )
}

export const CommandsIcon = () => {
    return (
        <svg className="icon users-icon" width="30" height="30" viewBox="0 0 24 24" fill="none">
        <path 
            d="m6.75 7.5 3 2.25-3 2.25m4.5 0h3m-9 8.25h13.5A2.25 2.25 0 0 0 21 18V6a2.25 2.25 0 0 0-2.25-2.25H5.25A2.25 2.25 0 0 0 3 6v12a2.25 2.25 0 0 0 2.25 2.25Z"
            strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" stroke="#231F20"/>
        </svg>
    )
}

export const ApiKeyIcon = () => {
    return (
        <svg className="icon users-icon" width="30" height="30" viewBox="0 0 24 24" fill="none">
        <path
            d="M15.75 5.25a3 3 0 0 1 3 3m3 0a6 6 0 0 1-7.029 5.912c-.563-.097-1.159.026-1.563.43L10.5 17.25H9v1.5H7.5v1.5H4.5a1.125 1.125 0 0 1-1.125-1.125v-2.25c0-.298.119-.585.33-.796l5.416-5.416c.404-.404.527-1 .43-1.563A6 6 0 1 1 21.75 8.25Z"
            stroke="#231F20" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}

export const NewsIcon = () => {
    return (
        <svg className="icon users-icon" width="30" height="30" viewBox="0 0 24 24" fill="none">
        <path
            d="M12 7.5h1.5m-1.5 3h1.5m-7.5 3h7.5m-7.5 3h7.5m3-9h3.375c.621 0 1.125.504 1.125 1.125V18a2.25 2.25 0 0 1-2.25 2.25M16.5 7.5V18a2.25 2.25 0 0 0 2.25 2.25M16.5 7.5V4.875c0-.621-.504-1.125-1.125-1.125H4.125C3.504 3.75 3 4.254 3 4.875V18a2.25 2.25 0 0 0 2.25 2.25h13.5M6 7.5h3v3H6v-3Z"
            stroke="#231F20" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}

export const PromoIcon = () => {
    return (
        <svg className="icon users-icon" width="30" height="30" viewBox="0 0 24 24" fill="none">
        <path
            d="M9.568 3H5.25A2.25 2.25 0 0 0 3 5.25v4.318c0 .597.237 1.17.659 1.591l9.581 9.581c.699.699 1.78.872 2.607.33a18.095 18.095 0 0 0 5.223-5.223c.542-.827.369-1.908-.33-2.607L11.16 3.66A2.25 2.25 0 0 0 9.568 3Z"
            stroke="#231F20" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M6 6h.008v.008H6V6Z"
            stroke="#231F20" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}

export const NotificationIcon = () => {
    return (
        <svg className="icon users-icon" width="30" height="30" viewBox="0 0 24 24" fill="none">
        <path
            d="M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0"
            stroke="#231F20" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}

export const CommentIcon = () => {
    return (
        <svg className="icon table-icon" width="30" height="30" viewBox="0 0 24 24" fill="none">
        <path 
            d="M2.25 12.76c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.076-4.076a1.526 1.526 0 0 1 1.037-.443 48.282 48.282 0 0 0 5.68-.494c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z"
            strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" stroke="#231F20"/>
        </svg>
    )
}

export const EcoModeOn = () => {
    return (
        <svg className="icon eco-on" width="30" height="30" viewBox="0 -5 30 30" fill="none">
            <path 
                d="M11.983 1.907a.75.75 0 0 0-1.292-.657l-8.5 9.5A.75.75 0 0 0 2.75 12h6.572l-1.305 6.093a.75.75 0 0 0 1.292.657l8.5-9.5A.75.75 0 0 0 17.25 8h-6.572l1.305-6.093Z"
                strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" stroke="#231F20"
            />

        </svg>
    )
}

export const EcoModeOff = () => {
    return (
        <svg className="icon eco-off" width="30" height="30" viewBox="0 -5 30 30" fill="none">
            <path 
                d="M2.22 2.22a.75.75 0 0 1 1.06 0l14.5 14.5a.75.75 0 1 1-1.06 1.06L2.22 3.28a.75.75 0 0 1 0-1.06Z"
                strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" stroke="#231F20" clipRule="evenodd"
            />
            <path 
                d="M4.73 7.912 2.191 10.75A.75.75 0 0 0 2.75 12h6.068L4.73 7.912ZM9.233 12.415l-1.216 5.678a.75.75 0 0 0 1.292.657l2.956-3.303-3.032-3.032ZM15.27 12.088l2.539-2.838A.75.75 0 0 0 17.25 8h-6.068l4.088 4.088ZM10.767 7.585l1.216-5.678a.75.75 0 0 0-1.292-.657L7.735 4.553l3.032 3.032Z"
                strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" stroke="#231F20"
            />

        </svg>
    )
}

export const EditIcon = () => {
    return (
        <svg className="icon table-icon" width="24" height="24" viewBox="0 -5 24 24" fill="none">
            <path 
                d="m5.433 13.917 1.262-3.155A4 4 0 0 1 7.58 9.42l6.92-6.918a2.121 2.121 0 0 1 3 3l-6.92 6.918c-.383.383-.84.685-1.343.886l-3.154 1.262a.5.5 0 0 1-.65-.65Z"
                strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" stroke="#231F20" clipRule="evenodd"
            />
            <path 
                d="M3.5 5.75c0-.69.56-1.25 1.25-1.25H10A.75.75 0 0 0 10 3H4.75A2.75 2.75 0 0 0 2 5.75v9.5A2.75 2.75 0 0 0 4.75 18h9.5A2.75 2.75 0 0 0 17 15.25V10a.75.75 0 0 0-1.5 0v5.25c0 .69-.56 1.25-1.25 1.25h-9.5c-.69 0-1.25-.56-1.25-1.25v-9.5Z"
                strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" stroke="#231F20"
            />

        </svg>
    )
}

export const DeleteIcon = () => {
    return (
        <svg className="icon table-icon" width="24" height="24" viewBox="0 -5 24 24" fill="none">
            <path 
                d="M8.75 1A2.75 2.75 0 0 0 6 3.75v.443c-.795.077-1.584.176-2.365.298a.75.75 0 1 0 .23 1.482l.149-.022.841 10.518A2.75 2.75 0 0 0 7.596 19h4.807a2.75 2.75 0 0 0 2.742-2.53l.841-10.52.149.023a.75.75 0 0 0 .23-1.482A41.03 41.03 0 0 0 14 4.193V3.75A2.75 2.75 0 0 0 11.25 1h-2.5ZM10 4c.84 0 1.673.025 2.5.075V3.75c0-.69-.56-1.25-1.25-1.25h-2.5c-.69 0-1.25.56-1.25 1.25v.325C8.327 4.025 9.16 4 10 4ZM8.58 7.72a.75.75 0 0 0-1.5.06l.3 7.5a.75.75 0 1 0 1.5-.06l-.3-7.5Zm4.34.06a.75.75 0 1 0-1.5-.06l-.3 7.5a.75.75 0 1 0 1.5.06l.3-7.5Z"
                strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" stroke="#231F20" clipRule="evenodd"
            />
        </svg>
    )
}

export const AddIcon = () => {
    return (
        <svg className="icon table-icon" width="24" height="24" viewBox="0 -5 24 24" fill="none">
            <path 
                d="M12 4.5v15m7.5-7.5h-15"
                strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" stroke="#231F20" clipRule="evenodd"
            />

        </svg>
    )
}

export const MinusIcon = () => {
    return (
        <svg className="icon table-icon" width="24" height="24" viewBox="0 -5 24 24" fill="none">
            <path 
                d="M5 12h14"
                strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" stroke="#231F20" clipRule="evenodd"
            />
        </svg>
    )
}

export const DeregisterIcon = () => {
    return (
        <svg className="icon table-icon" width="30" height="30" viewBox="0 0 30 30" fill="none">
            <path 
                d="M22 10.5h-6m-2.25-4.125a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0ZM4 19.235v-.11a6.375 6.375 0 0 1 12.75 0v.109A12.318 12.318 0 0 1 10.374 21c-2.331 0-4.512-.645-6.374-1.766Z"
                strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" stroke="#231F20" fillRule='evenodd' clipRule='evenodd' 
            />
        </svg>
    )
}

export const RegisterIcon = () => {
    return (
        <svg className="icon table-icon" width="30" height="30" viewBox="0 0 30 30" fill="none">
            <path 
                d="M18 7.5v3m0 0v3m0-3h3m-3 0h-3m-2.25-4.125a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0ZM3 19.235v-.11a6.375 6.375 0 0 1 12.75 0v.109A12.318 12.318 0 0 1 9.374 21c-2.331 0-4.512-.645-6.374-1.766Z"
                strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" stroke="#231F20" fillRule='evenodd' clipRule='evenodd' 
            />
        </svg>
    )
}

export const LinkOut = ({hasLink=true}) => {
    return (
        <svg className={hasLink?`icon table-icon`:`icon noerrors`} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M13.5 6H5.25A2.25 2.25 0 0 0 3 8.25v10.5A2.25 2.25 0 0 0 5.25 21h10.5A2.25 2.25 0 0 0 18 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
                stroke="#231F20" strokeWidth="1.25" strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export const ReportIcons = () => {
    return (
        <svg className="icon table-icon" width="30" height="30" viewBox="0 0 24 24" fill="none">
            <path 
                d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25M9 16.5v.75m3-3v3M15 12v5.25m-4.5-15H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
                strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" stroke="#231F20" fillRule='evenodd' clipRule='evenodd' 
            />
        </svg>
    )
}

export const ErrorsIcon = ({hasErrors=false, hasStatus=false}) => {
    return (
        <svg className={hasErrors?`icon error-icon errors`:hasStatus?`icon error-icon status`:`icon error-icon noerrors`} width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path 
                d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z"
                strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" stroke="#231F20" fillRule='evenodd' clipRule='evenodd' 
            />
        </svg>
    )
}

export const ChangesIcon = () => {
    return (
        <svg className="icon" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path 
                d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 5.25h.008v.008H12v-.008Z"
                strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" stroke="#231F20" fillRule='evenodd' clipRule='evenodd' 
            />
        </svg>
    )
}


export const PermissionsIcon = () => {
    return (
        <svg className="icon users-icon" width="30" height="30" viewBox="0 0 24 24" fill="none">
        <path 
            d="M15.75 5.25a3 3 0 0 1 3 3m3 0a6 6 0 0 1-7.029 5.912c-.563-.097-1.159.026-1.563.43L10.5 17.25H8.25v2.25H6v2.25H2.25v-2.818c0-.597.237-1.17.659-1.591l6.499-6.499c.404-.404.527-1 .43-1.563A6 6 0 1 1 21.75 8.25Z"
            stroke="#231F20" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}

export const UserGroupIcon = () => {
    return (
        <svg className="icon users-icon" width="30" height="30" viewBox="0 0 24 24" fill="none">
        <path 
            d="M18 18.72a9.094 9.094 0 0 0 3.741-.479 3 3 0 0 0-4.682-2.72m.94 3.198.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0 1 12 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 0 1 6 18.719m12 0a5.971 5.971 0 0 0-.941-3.197m0 0A5.995 5.995 0 0 0 12 12.75a5.995 5.995 0 0 0-5.058 2.772m0 0a3 3 0 0 0-4.681 2.72 8.986 8.986 0 0 0 3.74.477m.94-3.197a5.971 5.971 0 0 0-.94 3.197M15 6.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm6 3a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Zm-13.5 0a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"
            stroke="#231F20" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}

export const RolesIcon = () => {
    return (
        <svg className="icon users-icon" width="30" height="30" viewBox="0 0 24 24" fill="none">
        <path 
            d="M15 9h3.75M15 12h3.75M15 15h3.75M4.5 19.5h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5Zm6-10.125a1.875 1.875 0 1 1-3.75 0 1.875 1.875 0 0 1 3.75 0Zm1.294 6.336a6.721 6.721 0 0 1-3.17.789 6.721 6.721 0 0 1-3.168-.789 3.376 3.376 0 0 1 6.338 0Z"
            stroke="#231F20" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}

export const SunIcon = () => {
    return (
        <svg className="icon" width="30" height="30" viewBox="0 0 24 24" fill="none">
        <path 
            d="M12 3v2.25m6.364.386-1.591 1.591M21 12h-2.25m-.386 6.364-1.591-1.591M12 18.75V21m-4.773-4.227-1.591 1.591M5.25 12H3m4.227-4.773L5.636 5.636M15.75 12a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0Z"
            stroke="#231F20" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}

export const LightModeIcon = () => {
    return (
        <svg className="icon theme-icon" width="31" height="31" viewBox="0 0 25 25" fill="none"
             xmlns="http://www.w3.org/2000/svg">
            <path
                d="M12 3v2.25m6.364.386-1.591 1.591M21 12h-2.25m-.386 6.364-1.591-1.591M12 18.75V21m-4.773-4.227-1.591 1.591M5.25 12H3m4.227-4.773L5.636 5.636M15.75 12a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0Z" 
                stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}

export const DarkModeIcon = () => {
    return (
        <svg className="icon theme-icon" width="31" height="31" viewBox="0 0 25 25" fill="none"
             xmlns="http://www.w3.org/2000/svg">
            <path
                d="M21.752 15.002A9.72 9.72 0 0 1 18 15.75c-5.385 0-9.75-4.365-9.75-9.75 0-1.33.266-2.597.748-3.752A9.753 9.753 0 0 0 3 11.25C3 16.635 7.365 21 12.75 21a9.753 9.753 0 0 0 9.002-5.998Z"
                stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}

export const HomeIcon = () => {
    return (
        <svg className="icon users-icon" width="30" height="30" viewBox="0 0 24 24" fill="none">
        <path 
            d="m2.25 12 8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25"
            stroke="#231F20" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}

export const CircleIndicator = ({color='none'}) => {
    return (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="45">
            <path 
                d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" 
                stroke="var(--font-black)" 
                strokeWidth="0.50" 
                strokeLinecap="round" 
                strokeLinejoin="round"
                fill={color}>
            </path>
        </svg>
    )
}

export const PersonCountIcon= ({ count = 1, plus = false }) => {
    return (
      <div className="icon orp-count">
        {Array.from({ length: count }).map((_, idx) => (
          <svg
            key={idx}
            width="12"
            height="29"
            viewBox="0 0 12 29"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M2.34016 27C2.34016 27 0.186163 16.0977 1.33976 13.5C2.49336 10.9023 4.22149 11 5.83976 11C7.45804 11 9.18616 10.9023 10.3398 13.5C11.4934 16.0977 9.34017 27 9.34017 27C9.34017 27 7.96808 27.5066 5.83976 27.5C3.6392 27.5 2.34016 27 2.34016 27Z"
              stroke="#797D82"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M8.31472 6.97487C8.97109 6.3185 9.33984 5.42826 9.33984 4.5C9.33984 3.57174 8.97109 2.6815 8.31472 2.02513C7.65834 1.36875 6.7681 1 5.83984 1C4.91159 1 4.02135 1.36875 3.36497 2.02513C2.70859 2.6815 2.33984 3.57174 2.33984 4.5C2.33984 5.42826 2.70859 6.3185 3.36497 6.97487C4.02135 7.63125 4.91159 8 5.83984 8C6.7681 8 7.65834 7.63125 8.31472 6.97487Z"
              stroke="#797D82"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        ))}
        {plus && <span>+</span>}
      </div>
    );
  }

  export const FlagIconOutlined = () => {
    return (
        <svg className="icon table-icon" width="30" height="30" viewBox="0 0 24 24" fill="none">
        <path 
            d="M3 3v1.5M3 21v-6m0 0 2.77-.693a9 9 0 0 1 6.208.682l.108.054a9 9 0 0 0 6.086.71l3.114-.732a48.524 48.524 0 0 1-.005-10.499l-3.11.732a9 9 0 0 1-6.085-.711l-.108-.054a9 9 0 0 0-6.208-.682L3 4.5M3 15V4.5"
            stroke="#231F20" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}

export const FlagIconFilled = () => {
    return (
        <svg className="icon table-icon" width="30" height="30" viewBox="0 0 24 24" fill="var(--as-red)">
        <path 
            d="M3 2.25a.75.75 0 0 1 .75.75v.54l1.838-.46a9.75 9.75 0 0 1 6.725.738l.108.054A8.25 8.25 0 0 0 18 4.524l3.11-.732a.75.75 0 0 1 .917.81 47.784 47.784 0 0 0 .005 10.337.75.75 0 0 1-.574.812l-3.114.733a9.75 9.75 0 0 1-6.594-.77l-.108-.054a8.25 8.25 0 0 0-5.69-.625l-2.202.55V21a.75.75 0 0 1-1.5 0V3A.75.75 0 0 1 3 2.25Z"
            stroke="#231F20" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fillRule="evenodd" clipRule="evenodd"/>
        </svg>
    )
}

export const OzoneIcon = () => {
    return (
       <div className='onzen-ozone-icon' id='ozone-icon'/>
    )
}

export const OnzenIcon = () => {
    return (
        <div className='onzen-ozone-icon' id='onzen-icon'/>
    )
}

export const FilterIcon = () => {
    return (
        <div className='onzen-ozone-icon' id='filter-icon'/>
    )
}